import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { AuthenticationService, UserService } from 'src/app/_services';
import { ExportCSVService } from 'src/app/_services/export-csv.service';
import { SnackbarService } from 'src/app/_service/message-service';
import { ActivatedRoute } from '@angular/router';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Permission } from 'src/app/util/enums/permission.enum';
import { MenuRouteID } from '../header/menu-item/nav-item';
import { BillingService } from 'src/app/_services/billing.service.v2';
export interface transactionData {
  userId: number;
  userName: string;
  walletId: number;
  balance: number;
  amount: number;
  description: string;
  operation: string;
  dateTime: string;
  sequence: number;
  transactionId: string;
}
export interface pendingTransactions {
  orderId: string;
  amount: string;
  userId: string;
  contact: string;
  status: string;
  userName: string;
}

@Component({
  selector: 'telio-user-transactions',
  templateUrl: './user-transactions.component.html',
  styleUrls: ['./user-transactions.component.scss']
})
export class UserTransactionsComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription;
  transactionList: transactionData[];
  transactionIdList: transactionData[];
  uniqueTransactionList: transactionData[];
  initialTransactionData: any;
  pendingTransactionList: pendingTransactions[];
  failedTransactionList: pendingTransactions[];
  columns: TableColumn[];
  tcolumns: TableColumn[];
  pcolumns: TableColumn[];
  buttons: TableBtn[];
  pbuttons: TableBtn[];
  actionHeader: string = '';
  filterPlaceholder: string = '';
  userID;
  userDetails;
  tbuttons: TableBtn[];
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  sortColumn = '';
  sortDirection = 'asc';
  transactionIdCount = 0;
  pendingCount = 0;
  failedCount = 0;
  availableTabs = [
    { id: MenuRouteID.TABS.COMPLETED_TRANS, enable: false },
    { id: MenuRouteID.TABS.PENDING_TRANS, enable: false },
    { id: MenuRouteID.TABS.FAILED_TRANS, enable: false }
  ];

  @ViewChild('transactionDialog', { static: false }) transactionDialog: TemplateRef<any>;
  @ViewChild('viewUserDetails', { static: false }) viewUserDetails: TemplateRef<any>;
  constructor(private userservice: UserService,
    private toastr: SnackbarService,
    public dialog: MatDialog,private billingService:BillingService,
    readonly route: ActivatedRoute,
    private userInfoService: UserInfoService, private authenticationService: AuthenticationService,
    readonly translate: TranslateService, readonly exportCSVService: ExportCSVService) {
    this.getAllTransactions();
    this.rerenderPendingTrans(this.pageList, '');
    this.rerenderFailedTrans(this.pageList, '')
  }

  ngOnInit(): void {
    this.availableTabs = this.userInfoService.getPermittedTabs(+this.route.snapshot.paramMap.get('routeID'), this.availableTabs);
    let tabExists = this.availableTabs.filter(res => res.enable);
    !tabExists || tabExists.length == 0 ? this.toastr.info(this.translate.instant('unAuthorized')) : '';
    this.columns = [
      { columnDef: 'user_name', header: 'wallets.userName', cell: (element: transactionData) => `${element.userName}`, sortingDisabled: false, width: '80px', caseSensitive: 'capitalize', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
      { columnDef: 'user_id', header: 'wallets.userId', cell: (element: transactionData) => `${element.userId}`, sortingDisabled: false, width: '80px' },
      { columnDef: 'wallet_id', header: 'wallets.walletId', cell: (element: transactionData) => `${element.walletId}`, sortingDisabled: false, width: '80px', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
      { columnDef: 'balance', header: 'wallets.balance', cell: (element: transactionData) => `${element.balance}`, sortingDisabled: false, isCurrency: true, width: '80px', align: 'right', headerAlign: true },
    ];

    this.tcolumns = [
      { columnDef: 'user_name', header: 'wallets.userName', cell: (element: transactionData) => `${element.userName}`, sortingDisabled: true, caseSensitive: 'capitalize' },
      { columnDef: 'user_id', header: 'wallets.userId', cell: (element: transactionData) => `${element.userId}`, sortingDisabled: true },
      { columnDef: 'wallet_id', header: 'wallets.walletId', cell: (element: transactionData) => `${element.walletId}`, sortingDisabled: true },
      { columnDef: 'amount', header: 'wallets.amountWithCurrency', cell: (element: transactionData) => `${element.amount}`, sortingDisabled: false, isCurrency: true, align: 'right', headerAlign: true },
      { columnDef: 'balance', header: 'wallets.balance', cell: (element: transactionData) => `${element.balance}`, sortingDisabled: false, align: 'right', isCurrency: true, headerAlign: true },
      { columnDef: 'operation', header: 'wallets.operation', cell: (element: transactionData) => `${element.operation}`, sortingDisabled: false, caseSensitive: 'capitalize' },
      { columnDef: 'description', header: 'transactions.description', cell: (element: transactionData) => `${element.description}`, sortingDisabled: false, caseSensitive: 'capitalize' },
      { columnDef: 'dateTime', header: 'wallets.paymentDate', cell: (element: transactionData) => `${element.dateTime}`, sortingDisabled: false }
    ];

    this.pcolumns = [
      { columnDef: 'user_name', header: 'wallets.userName', cell: (element: pendingTransactions) => `${element.userName}`, sortingDisabled: true, isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ) },
      { columnDef: 'user_id', header: 'transactions.userId', cell: (element: pendingTransactions) => `${element.userId}`, sortingDisabled: true },
      { columnDef: 'order_id', header: 'transactions.orderId', cell: (element: pendingTransactions) => `${element.orderId}`, sortingDisabled: true },
      { columnDef: 'contact', header: 'transactions.contact', cell: (element: pendingTransactions) => `${element.contact}`, sortingDisabled: true },
      { columnDef: 'amount', header: 'wallets.amountWithCurrency', cell: (element: pendingTransactions) => `${element.amount}`, sortingDisabled: true, isCurrency: true, align: 'right', headerAlign: true, width: '100px' },
      { columnDef: 'status', header: 'transactions.status', cell: (element: pendingTransactions) => `${element.status}`, sortingDisabled: true, caseSensitive: 'uppercase' },
    ];

    this.filterPlaceholder = 'generalTable.filterPlaceholder';
  }

  getAllTransactions() {
    this.subscription.add(this.userservice.getAllTransacations().subscribe((resp: any) => {
      this.transactionList = resp;
      if (!!resp) {
        this.transactionList.map((item: any, i: number) => {
          let empty = 'NA';
          item.userId = !item.user_id ? empty : item.user_id
          item.userName = !item.user_name ? empty : item.user_name.toLowerCase()
          item.transactionId = !item.transactionId ? empty : item.transactionId
          item.walletId = !item.wallet_id ? empty : item.wallet_id
          item.balance = (+item.available_balance).toFixed(2)
          item.amount = (+item.amount).toFixed(2)
          item.description = !item.description ? empty : item.description.toLowerCase()
          item.operation = !item.operation ? empty : item.operation.toLowerCase()
          item.dateTime = !item.payment_date ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.payment_date, this.userInfoService.userDetails.prefCountry));
          item.sequence = item.sequence
        });
      }
      this.initialTransactionData = this.transactionList;
      this.uniqueTransactionList = this.transactionList.filter((ele) => ele.sequence === 1)
      this.totalDataCount = this.uniqueTransactionList.length
    },
      error => {
        this.transactionList = [];
      }))
  }

  getPendingTransactions(value, searchFilter) {
    this.subscription.add(this.userservice.getPendingTransactions(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((resp: any) => {
      if (!!resp) {
        this.pendingTransactionList = resp.content;
        this.pendingCount = resp.total_items;
        this.setPendingMap(this.pendingTransactionList)
      }
      else {
        this.pendingTransactionList = []
      }
    },
      error => {
        this.pendingTransactionList = []
      }))
  }

  getFailedTransactions(value, searchFilter) {
    this.subscription.add(this.userservice.getFailedTransactions(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter).subscribe((resp: any) => {
      if (!!resp) {
        this.failedTransactionList = resp.content;
        this.failedCount = resp.total_items
        this.setFailedMap(this.failedTransactionList)
      }
      else {
        this.failedTransactionList = []
      }
    },
      error => {
        this.failedTransactionList = []
      }
    ))
  }

  actionCSV() {
    let empty = 'NA'
    const options = {
      filename: this.translate.instant('transactions.completedTransactions'),
      showTitle: false,
      title: this.translate.instant('transactions.completedTransactions'),
      useKeysAsHeaders: true,
    }
    const transformedData = this.initialTransactionData.map(item => ({
      userId: !item.user_id ? empty : item.user_id,
      userName: !item.user_name ? empty : item.user_name.toLowerCase(),
      walletId: !item.wallet_id ? empty : item.wallet_id,
      balance: (+item.available_balance).toFixed(2),
      amount: (+item.amount).toFixed(2),
      description: !item.description ? empty : item.description.toLowerCase(),
      operation: !item.operation ? empty : item.operation.toLowerCase(),
      dateTime: !item.payment_date ? empty : this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(item.payment_date, this.userInfoService.userDetails.prefCountry)),
      payment_id: !item.payment_id ? empty : item.payment_id,
      sequence: item.sequence
    }));
    this.exportCSVService.exportCSV(options, transformedData);
  }

  actionCSVId() {
    const options = {
        filename: this.translate.instant('transactions.completedTransactions'),
        showTitle: false,
        title: this.translate.instant('transactions.completedTransactions'),
        useKeysAsHeaders: true,
    };
    const exportData = this.transactionIdList.map((item: any) => {
        const { user_id, user_name, wallet_id, dateTime, balance, ...filteredItem } = item;
        if (filteredItem.payment_date) {
          filteredItem.payment_date = this.authenticationService.convert24HrTo12Hr(this.authenticationService.convertToLocalTime(filteredItem.payment_date,this.userInfoService.userDetails.prefCountry));
      }
        return filteredItem;
    });

    this.exportCSVService.exportCSV(options, exportData);
}

  pendingCSV() {
    let empty = 'NA'
    const options = {
      filename: this.translate.instant('transactions.pendingTransactions'),
      showTitle: false,
      title: this.translate.instant('transactions.pendingTransactions'),
      useKeysAsHeaders: true,
    }
    this.subscription.add(this.userservice.getPendingTransactions(1, this.pendingCount, this.sortColumn, 'asc', '').subscribe((resp: any) => {
      let csvData = resp.content;
      const transformedData = csvData.map(item => ({
        userName: !item.user_name ? empty : item.user_name,
        userId: !item.user_id ? empty : item.user_id,
        orderId: !item.order_id ? empty : item.order_id,
        contact: !item.contact ? empty : item.contact,
        status: !item.status ? empty : item.status.toLowerCase(),
        amount: (+item.amount).toFixed(2)
      }));
      this.exportCSVService.exportCSV(options, transformedData);
    }))
  }

  failedCSV() {
    let empty = 'NA'
    const options = {
      filename: this.translate.instant('transactions.failedTransactions'),
      showTitle: false,
      title: this.translate.instant('transactions.failedTransactions'),
      useKeysAsHeaders: true,
    }
    this.subscription.add(this.userservice.getFailedTransactions(1, this.failedCount, this.sortColumn, 'asc', '').subscribe((resp: any) => {
      let csvData = resp.content;
      const transformedData = csvData.map(item => ({
        userId: !item.user_id ? empty : item.user_id,
        orderId: !item.order_id ? empty : item.order_id,
        contact: !item.contact ? empty : item.contact,
        status: !item.status ? empty : item.status.toLowerCase(),
        amount: (+item.amount).toFixed(2)
      }));
      this.exportCSVService.exportCSV(options, transformedData);
    }
    ))
  }

  openTransactionDailog() {
    let dialogRef = this.dialog.open(this.transactionDialog, {
      height: '550px',
      width: '1000px'
    }).afterClosed().subscribe((res: any) => {
    })
  }

  pbuttonClick(result: string[]) {
    let tempArray = result[1].split(',')
    let orderId = tempArray[0]
    let userId = tempArray[1]
    this.subscription.add(this.userservice.refreshStatus(orderId, userId).subscribe((resp: any) => {
      if (!!resp) {
        this.rerenderPendingTrans(this.pageList, '')
      }
    },
      error => {
        this.toastr.error(error)
      }))
  }

  actionClick() {
    this.getAllTransactions()
  }

  pactionClick() {
    this.rerenderPendingTrans(this.pageList, '')
  }

  factionClick() {
    this.rerenderFailedTrans(this.pageList, '')
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }

  pdfDownload(id) {
    this.billingService.getInvoice(id).subscribe((res: any) => {
      const url = window.URL.createObjectURL(res);
      window.open(url);
    })
  }


  buttonsClick(event) {
    let data = this.transactionIdList.filter(x => x.transactionId == event[1]);
    if (data.length > 0 && data[0].operation.toLowerCase() == 'debit')
      this.pdfDownload(event[1]);
    else
      this.toastr.info(this.translate.instant('wallets.downloadError'))
  }


  userDetail(item) {
    this.userservice.getUserDetails(item.userId).subscribe((resp: any) => {
      if (!!resp) {
        this.userDetails = resp.data;
        let empty = 'NA';
        let event = this.userDetails
        event.username = !event.username ? empty : event.username;
        event.email = !event.email ? empty : event.email;
        event.emailValidated = event.email_validated;
        event.mobile = !event.mobile ? empty : event.mobile;
        event.mobileValidated = event.mobile_validated;
        event.countryCode = !event.country_code ? '' : event.country_code;
        event.roles = (!event.roles && event.roles.length > 0) ? empty : event.roles[0].name;
        event.status = !event.status ? empty : event.status.toUpperCase();
        event.tenantId = !event.tenant_id ? empty : event.tenant_id;
        event.signupType = !event.signup_type ? empty : event.signup_type;
        event.prefLanguage = !event.pref_language ? empty : event.pref_language.toUpperCase();
        event.pancard = !event.pancard ? empty : event.pancard;
        event.gstNumber = !event.gst_number ? empty : event.gst_number;
        event.state = !event.state ? empty : event.state;
        event.vehicleRegNo = !event.vehicle_reg_no ? empty : event.vehicle_reg_no;

        let dialogRef = this.dialog.open(this.viewUserDetails, {
          height: '500px',
          width: '800px'
        }).afterClosed().subscribe((res: any) => {
        })
      } else {
        this.toastr.error(this.translate.instant('generalTable.noRecord'));
      }
    }, error => {
      this.toastr.error(this.translate.instant('generalTable.noRecord'));
    })
  }


  linkClick(event) {
    this.userID = event.row.userId;
    let id = +event.row.userId;
    if (event.column.columnDef == "wallet_id") {
      this.transactionIdList = this.transactionList.filter((ele) => ele.userId == id);
      this.transactionIdCount = this.transactionIdList.length
      this.openTransactionDailog();
    }

    if (event.column.columnDef == "user_name") {
      this.userDetail(event.row);
    }

    if (event.column.columnDef == "user_id") {
      this.userDetail(event.row);
    }
  }

  rerenderAllTrans(value: any, searchFilter?: string) {
    this.getAllTransactions();
  }

  loadAllData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerenderAllTrans(val, '')
  }

  sortAllClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerenderAllTrans(this.pageList, '');
  }

  applyFilterAll(filteredData: string) {
    this.rerenderAllTrans(this.pageList, filteredData)
  }

  rerenderPendingTrans(value: any, searchFilter?: string) {
    this.getPendingTransactions(value, searchFilter);
  }

  loadPendingData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerenderPendingTrans(val, '')
  }

  sortPendingClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerenderPendingTrans(this.pageList, '');
  }

  applyFilterPending(filteredData: string) {
    this.rerenderPendingTrans(this.pageList, filteredData)
  }

  rerenderFailedTrans(value: any, searchFilter?: string) {
    this.getFailedTransactions(value, searchFilter);
  }

  loadFailedData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.rerenderFailedTrans(val, '')
  }

  sortFailedClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.rerenderFailedTrans(this.pageList, '');
  }

  applyFilterFailed(filteredData: string) {
    this.rerenderFailedTrans(this.pageList, filteredData)
  }

  setPendingMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      item.userName = !item.user_name ? empty : item.user_name
      item.userId = !item.user_id ? empty : item.user_id
      item.orderId = !item.order_id ? empty : item.order_id
      item.contact = !item.contact ? empty : item.contact
      item.status = !item.status ? empty : item.status.toLowerCase()
      item.amount = (+item.amount).toFixed(2)
    });
  }

  setFailedMap(data) {
    data.map((item: any, i: number) => {
      let empty = 'NA';
      item.userId = !item.user_id ? empty : item.user_id
      item.orderId = !item.order_id ? empty : item.order_id
      item.contact = !item.contact ? empty : item.contact
      item.status = !item.status ? empty : item.status.toLowerCase()
      item.amount = (+item.amount).toFixed(2)
    });
  }

}
